import {Tooltip} from "@material-ui/core";
import {roundToFixed} from "../../../services/util/helperFuncs";
import React from "react";

export const TourDurationCell = ({ travelDurationInMin, tour, t }) => {

  const dwellTimeDurationInMin =
      tour.templateStopInstances?.reduce(
          (sum, { dwellTime = 0 }) => sum + dwellTime,
          0
      ) ?? 0;

  console.log(dwellTimeDurationInMin)
  return (
    <Tooltip title={
      <div>
        <strong>{t('driveTime')}:</strong> {roundToFixed(travelDurationInMin, 0)}
        <br/>
        <strong>{t('dwellTime')}:</strong> {roundToFixed(dwellTimeDurationInMin, 0)}
      </div>
    }>
      <div>
        {roundToFixed(travelDurationInMin + dwellTimeDurationInMin)}
      </div>
    </Tooltip>
  );
};